export const mockBanner = [
  {
    id: 1,
    name: "ชื่อแคมเปญ ",
    link: "/",
    view: 234,
    image: "/img/banner.png",
  },
  {
    id: 2,
    name: "โรงเรียนเพื่อชีวิต ",
    link: "/",
    view: 234,
    image: "/img/banner2.png",
  }
]